// Passo a passo para criar a conta de anúncios e cadastrar a forma de pagamento em cada plataforma.
// O dinheiro dos anúncios vai direto para a plataforma; aqui só explicamos o caminho. Os nomes de menu
// mudam de vez em quando, por isso cada guia tem dicas e o link da ajuda oficial.
import type { BuilderPlatform } from '@impulso/shared/api/builder'

export interface PaymentGuide {
  id: BuilderPlatform
  name: string
  /** Onde a pessoa começa */
  startUrl: string
  createSteps: string[]
  paymentSteps: string[]
  tips: string[]
  helpUrl: string
}

export const PAYMENT_GUIDES: PaymentGuide[] = [
  {
    id: 'meta',
    name: 'Instagram e Facebook (Meta)',
    startUrl: 'https://business.facebook.com',
    createSteps: [
      'Entre em business.facebook.com com o seu Facebook. Se for a primeira vez, crie o portfólio empresarial com o nome do seu negócio.',
      'Abra Configurações → Contas → Contas de anúncios e clique em Adicionar → Criar nova conta de anúncios.',
      'Escolha o fuso horário de Brasília e a moeda Real (BRL). Depois de criada, a moeda não muda.',
      'Ligue a sua página do Facebook e o seu Instagram ao mesmo portfólio, em Configurações → Contas.',
    ],
    paymentSteps: [
      'No Gerenciador de Anúncios, abra o menu → Cobrança e pagamentos → Configurações de pagamento.',
      'Clique em Adicionar forma de pagamento e informe o CPF ou o CNPJ de quem paga.',
      'Escolha cartão de crédito (a Meta cobra conforme você gasta) ou Pix/boleto (você coloca saldo antes).',
      'Se escolheu Pix ou boleto, clique em Adicionar fundos e pague. Pix cai na hora; boleto leva até 3 dias úteis.',
    ],
    tips: [
      'Com Pix ou boleto, os anúncios param quando o saldo acaba. Vale colocar um valor que cubra pelo menos uma semana.',
      'Se o cartão for recusado, a Meta pausa a conta até a dívida ser paga. Confira o limite antes.',
    ],
    helpUrl: 'https://www.facebook.com/business/help',
  },
  {
    id: 'google_ads',
    name: 'Google Ads',
    startUrl: 'https://ads.google.com',
    createSteps: [
      'Entre em ads.google.com com a conta Google do negócio e clique em Começar agora.',
      'Se o Google pedir para criar uma campanha logo de cara, procure a opção de criar a conta sem campanha (ou mudar para o Modo Especialista). A campanha você faz aqui no Seu Impulso.',
      'Confirme o país Brasil, o fuso horário de Brasília e a moeda Real (BRL). Depois de criada, a moeda não muda.',
    ],
    paymentSteps: [
      'No menu da esquerda, abra Faturamento → Configurações.',
      'Preencha o perfil de pagamentos com CPF ou CNPJ, nome e endereço de quem paga.',
      'Escolha pagamentos automáticos com cartão (o Google cobra depois do gasto) ou pagamentos manuais com Pix ou boleto (você coloca saldo antes).',
      'Se escolheu pagamento manual, clique em Fazer um pagamento e pague o Pix ou o boleto.',
    ],
    tips: [
      'O Seu Impulso só publica quando o Google mostra a forma de pagamento como aprovada. Boleto pode levar alguns dias para compensar.',
      'Com pagamento manual, os anúncios param quando o saldo acaba.',
    ],
    helpUrl: 'https://support.google.com/google-ads',
  },
  {
    id: 'tiktok',
    name: 'TikTok',
    startUrl: 'https://ads.tiktok.com',
    createSteps: [
      'Entre em ads.tiktok.com e clique em Criar agora (ou Cadastre-se).',
      'Escolha o país Brasil, o fuso horário de Brasília e a moeda Real (BRL). Depois de criada, a moeda não muda.',
      'Preencha os dados do negócio (nome, site e CNPJ ou CPF) e envie. O TikTok revisa a conta antes de liberar os anúncios.',
    ],
    paymentSteps: [
      'No TikTok Ads Manager, abra Ferramentas (ou o menu da conta) → Pagamento.',
      'Escolha pagamento automático com cartão (o TikTok cobra conforme você gasta) ou pagamento manual, colocando saldo antes.',
      'No pagamento manual, clique em Adicionar saldo e pague com as opções que aparecerem para a sua conta (cartão, Pix ou boleto).',
    ],
    tips: [
      'A revisão da conta costuma levar de algumas horas a um dia. Os anúncios só rodam depois dela.',
      'No pagamento manual, os anúncios param quando o saldo acaba.',
    ],
    helpUrl: 'https://ads.tiktok.com/help',
  },
]

export const paymentGuideFor = (id: string | null | undefined) => PAYMENT_GUIDES.find((g) => g.id === id)
